import { render, staticRenderFns } from "./AddPriceDialog.vue?vue&type=template&id=b15a7e12&scoped=true"
import script from "./AddPriceDialog.vue?vue&type=script&lang=js"
export * from "./AddPriceDialog.vue?vue&type=script&lang=js"
import style0 from "./AddPriceDialog.vue?vue&type=style&index=0&id=b15a7e12&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15a7e12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b15a7e12')) {
      api.createRecord('b15a7e12', component.options)
    } else {
      api.reload('b15a7e12', component.options)
    }
    module.hot.accept("./AddPriceDialog.vue?vue&type=template&id=b15a7e12&scoped=true", function () {
      api.rerender('b15a7e12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/AddPriceDialog.vue"
export default component.exports